// extracted by mini-css-extract-plugin
export default {"number":"X522DIRkM9RrppEsEKtn","perc":"stUaIr3vX7HDJVjKRXGd"};